import React, { useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import {
  Grid,
  GridColumn,
  GridRow,
  Gutter,
  PageContext,
  Suspense,
} from '@axiom/ui';

import DefaultLayout from '../layouts/default';
import { WorkspaceTabs } from '../components/Workspace/WorkspaceTabs';
import { WorkspaceTopTasks } from '../components/Workspace/WorkspaceTopTasks';
import { ManageEmailAlertsModal } from '../components/ManageEmailAlertsModal/ManageEmailAlertsModal';
import { ManageClientsModal } from '../components/ManageClientsModal/ManageClientsModal';

export type WorkspacePageProps = {
  name?: string;
};

export const WorkspacePage = ({
  name = 'WORKSPACE_PAGE',
}: WorkspacePageProps) => {
  const { setTitle } = useContext(PageContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const contactId = searchParams.get('manageClient');

  const [showEmailAlertsModal, setShowEmailAlertsModal] = useState(
    searchParams.get('showEmailAlertsModal') !== null
  );
  const [showManageClientsModal, setShowManageClientsModal] =
    useState(!!contactId);

  useEffect(() => {
    setTitle('Workspace');
  }, [setTitle]);

  return (
    <div data-test={name}>
      <DefaultLayout name="DEFAULT_LAYOUT" hideSideDrawer>
        <Grid columns={12} stretched>
          <GridRow>
            <GridColumn
              widescreenWidth={2}
              desktopWidth={3}
              smallScreenWidth={3}
            >
              <WorkspaceTopTasks />
            </GridColumn>
            <GridColumn
              widescreenWidth={10}
              desktopWidth={9}
              smallScreenWidth={9}
            >
              <WorkspaceTabs />
            </GridColumn>
          </GridRow>
        </Grid>
        <Gutter bottom="24px" />
      </DefaultLayout>
      {showEmailAlertsModal ? (
        <Suspense fallback={null}>
          <ManageEmailAlertsModal
            onClose={() => {
              setShowEmailAlertsModal(false);
              searchParams.delete('showEmailAlertsModal');
              setSearchParams(searchParams);
            }}
            onNavigateToCandidate={() => {
              setShowEmailAlertsModal(false);
            }}
            onNavigateToSavedSearches={() => {
              setShowEmailAlertsModal(false);
            }}
          />
        </Suspense>
      ) : null}
      {showManageClientsModal ? (
        <Suspense>
          <ManageClientsModal
            contactId={contactId}
            onClose={() => {
              setShowManageClientsModal(false);
              searchParams.delete('manageClient');
              setSearchParams(searchParams, { replace: true });
            }}
          />
        </Suspense>
      ) : null}
    </div>
  );
};
